import React from 'react'

interface Props {
    data: any
}

export const DeleteModalChild = ({ data }: Props) => {
    return (<h1 style={{ fontSize: "15px" }}>Are you sure want to delete?</h1>)
}